import { ModelValidation } from "@/models/modelvalidation";

export class AndroidContent extends ModelValidation {
    public callDescription!: string | null;
    public callerName!: string | null;
    public contactImageData!: string | null;

    public fontColorLarge!: string | null;
    public textLarge!: string | null;
    public imageDataLarge!: string | null;
    public justifyLarge!: string | null;

    public fontColorSmall!: string | null;
    public textSmall!: string | null;
    public imageDataSmall!: string | null;
    public justifySmall!: string | null;

    public templateName: string;

    constructor(android: any) {
        super();
        
        if (android.contact) {
            this.callDescription = android.contact.callDescription || null;
            this.callerName = android.contact.callerName || null;
            this.contactImageData = android.contact.imageData || null;
        } else {
            this.callDescription = null;
            this.callerName = null;
            this.contactImageData = null;
        }

        if (android.largeOverlay != null) {
            this.fontColorLarge = android.largeOverlay!.templateData.fontColor || null;
            this.textLarge = android.largeOverlay!.templateData.text || null;
            this.imageDataLarge = android.largeOverlay!.templateData.imageData || null;
            this.justifyLarge = android.largeOverlay!.templateData.justify || null;
        }

        if(android.smallOverlay != null) {
            this.fontColorSmall = android.smallOverlay!.templateData.fontColor || null;
            this.textSmall = android.smallOverlay!.templateData.text || null;
            this.imageDataSmall = android.smallOverlay!.templateData.imageData || null;
            this.justifySmall = android.smallOverlay!.templateData.justify || null;
        }

        this.templateName = "androidOverlaySimpleImageWithText";
    }

    public static empty(): AndroidContent
    {
        return new AndroidContent({
            contact: {
                callerName: null,
                callDescription: null,
                imageData: null,
            },
            smallOverlay: {
                templateData: {
                    imageData: null,
                    text: null,
                    fontColor: null,
                }
            },
            largeOverlay: {
                templateData: {
                    imageData: null,
                    text: null,
                    fontColor: null,
                }
            }
        });
    }

    public toUpdateContentDto(): any {

        if(isNonUsProd) {
            return {
                contact: {
                    callerName: this.callerName,
                    callDescription: "${MY_VAR}$",
                    imageData: this.contactImageData
                },
                smallOverlay: null,
                largeOverlay: null
            }
        }

        return {
            contact: {
                callerName: this.callerName,
                callDescription: "${MY_VAR}$",
                imageData: this.contactImageData
            },
            smallOverlay: null,
            largeOverlay: null
        }
    }

    public updateContactImage(imgData: string): void {
        const tag = "data:image/jpeg;base64,";

        if (imgData!.includes(tag)) {
            this.contactImageData = imgData;
        } else {
            this.contactImageData = tag + imgData;
        }
    }

    public updateLargeImage(imgData: string): void {
        const tag = "data:image/jpeg;base64,";

        if (imgData!.includes(tag)) {
            this.imageDataLarge = imgData;
        } else {
            this.imageDataLarge = tag + imgData;
        }
    }

    public updateSmallImage(imgData: string): void {
        const tag = "data:image/jpeg;base64,";

        if (imgData!.includes(tag)) {
            this.imageDataSmall = imgData;
        } else {
            this.imageDataSmall = tag + imgData;
        }
    }

    public isValid(): boolean {
        var isValid = false;
        isNonUsProd = true;
        if (isNonUsProd) {
            if(
                (this.callerName && this.callerName.length > 0) &&
                (this.contactImageData && this.contactImageData.length > 0)
            ) {
                isValid = true;
            }
        } else {
            if(
                (this.callerName && this.callerName.length > 0) &&
                (this.contactImageData && this.contactImageData.length > 0) &&
                (this.imageDataLarge && this.imageDataLarge.length > 0) &&
                (this.imageDataSmall && this.imageDataSmall.length > 0)
            ) {
                isValid = true;
            }
        }

        return isValid;

    }
}
